import { render, staticRenderFns } from "./AmountSelection.vue?vue&type=template&id=a3593732&"
import script from "./AmountSelection.vue?vue&type=script&lang=js&"
export * from "./AmountSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports